import useGlobalContext from '../../hooks/useGlobalContext';
import clientList from '../../json/carouselClients.json';
import Carousel from '../components/carousel';

const Clients = () => {
  const {sitevNumLineas} = useGlobalContext();
  

  return (
    <section className="clients-section" id="clients">
    
      <div className="clients-container">
        <div className="clients-container2">
          <h2 className="clients__subtitle">Nuestros Clientes</h2>
          <p className="clients__details">
            SITEV se utiliza en más de {sitevNumLineas} líneas de inspección técnica vehicular a nivel nacional.
            <br/>
            Estos son algunos de nuestros casos de éxito:
          </p>
          <Carousel listImages={clientList} enableTimer={false} height={"h-200"}/>

        </div>
        
      </div>
    </section>
  )
}
 
export default Clients;